// DEPENDENCIES
import React from 'react';
// COMPONENTS
import { Link } from 'react-router-dom';
// ICONS
import { HiMenuAlt2 } from 'react-icons/hi';
// CUSTOM COMPONENTS
import CustomBlock from './CustomBlock';
import LogoBlock from './LogoBlock';
// ASSETS
import LogoIcon from '../assets/svg/icon.svg';
// SERVICES AND HELPERS
import constants from '../constants/constants';

const HeaderBlock = (props) => {

    return (
        <CustomBlock
            className={`header-block-container ${props.backgroundColor ? props.backgroundColor : "white--bg"}`}
        >
            {
                props.toLeft == "" ? <div className="header-left"></div> :
                    <Link
                        to={props.toLeft}
                        onClick={props.onClickLeft ? props.onClickLeft : () => { }}
                        className="header-left"
                    >
                        <LogoBlock
                            type="icon"
                            height={50}
                            className="icon-block-container"
                            imageClassName="icon"
                        />
                    </Link>
            }

            <CustomBlock
                className="header-title"
            >
                {
                    props.companyLogo ?
                        <LogoBlock
                            type="icon"
                            height={50}
                            className="icon-block-container"
                            containerStyle={{ justifyContent: "center" }}
                            imageClassName="icon"
                            src={constants.API_URL + 'Attachments' + props.companyLogo}
                        /> :
                        <h2>
                            {props.title}
                        </h2>
                }
            </CustomBlock>
            
            {
                !props.noDrawer &&
                <Link
                    to={props.toRight ? props.toRight : "#"}
                    onClick={props.onClickRight ? props.onClickRight : () => { }}
                    className="header-right"
                >
                    {
                        props.iconRight ? props.iconRight : <HiMenuAlt2 size={50} color="#0A4270" />
                    }
                </Link>
            }

        </CustomBlock>
    );
}

export default HeaderBlock;